import React from 'react';
import { GoogleMap, LoadScript, MarkerF } from '@react-google-maps/api';

type MapDisplayProps = {
  location: { latitude: string | number; longitude: string | number };
};

const containerStyle = {
  width: '100%',
  height: '100%',
  border: '1px solid black',
};

// カスタムマップスタイルの JSON 全文
const customMapStyles = [
  {
    stylers: [{ color: '#fffeef' }],
  },
  {
    elementType: 'geometry',
    stylers: [{ color: '#f5f5f5' }],
  },
  {
    elementType: 'geometry.fill',
    stylers: [{ color: '#d6d6d6' }],
  },
  {
    elementType: 'geometry.stroke',
    stylers: [{ color: '#7a7a7a' }],
  },
  {
    elementType: 'labels.icon',
    stylers: [{ visibility: 'off' }],
  },
  {
    elementType: 'labels.text.fill',
    stylers: [{ color: '#616161' }],
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [{ color: '#f5f5f5' }],
  },
  {
    featureType: 'administrative.land_parcel',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#bdbdbd' }],
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [{ color: '#eeeeee' }],
  },
  {
    featureType: 'poi',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#757575' }],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [{ color: '#ebebeb' }],
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#9e9e9e' }],
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [{ color: '#fffeef' }],
  },
  {
    featureType: 'road.arterial',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#757575' }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [{ color: '#c0c0c0' }],
  },
  {
    featureType: 'road.highway',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#616161' }],
  },
  {
    featureType: 'road.local',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#9e9e9e' }],
  },
  {
    featureType: 'transit.line',
    elementType: 'geometry',
    stylers: [{ color: '#e5e5e5' }],
  },
  {
    featureType: 'transit.line',
    elementType: 'geometry.fill',
    stylers: [{ color: '#929292' }],
  },
  {
    featureType: 'transit.station',
    elementType: 'geometry',
    stylers: [{ color: '#aaaaaa' }],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [{ color: '#c9c9c9' }],
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#9e9e9e' }],
  },
];

const MapDisplay: React.FC<MapDisplayProps> = ({ location }) => {
  // locationから数値に変換
  const lat =
    typeof location.latitude === 'string'
      ? parseFloat(location.latitude)
      : location.latitude;
  const lng =
    typeof location.longitude === 'string'
      ? parseFloat(location.longitude)
      : location.longitude;

  if (!lat || !lng) {
    return <p>No location data available.</p>;
  }

  const center = { lat, lng };

  const mapOptions = {
    styles: customMapStyles,
  };

  return (
    <LoadScript googleMapsApiKey="AIzaSyBtycuGSReV8YtA3igq4PQrXKS0YmDl3aY">
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={16}
        options={mapOptions}
      >
        <MarkerF position={center} />
      </GoogleMap>
    </LoadScript>
  );
};

export default MapDisplay;
